<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">About-Us Banner</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Banner
        </span>
      </base-button>
    </div>
    <BannerTable />
  </b-card>
</template>

<script>
import BannerTable from "./components/bannerTable.vue";
export default {
  components: {
    BannerTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "add-aboutus-banner" });
    },
  },
};
</script>
<style></style>
